<template>
  <el-table :data="gunDataTable" stripe style="width: 100%" ref="gunDataTable" border v-loading="listLoading">
    <!--                <af-table-column type="selection" width="30"></af-table-column>-->
    <af-table-column prop="gunCode" width="180" label="枪编号"></af-table-column>
    <af-table-column prop="gunNum" width="70" label="枪口号"></af-table-column>
    <af-table-column prop="gunName" width="120" label="枪名称" ></af-table-column>
    <af-table-column prop="pileCode" label="桩编号"></af-table-column>
    <af-table-column prop="stationName" width="180" label="所属场站"></af-table-column>
    <af-table-column prop="operatorName" width="200" label="所属运营商"></af-table-column>
    <af-table-column width="120" label="枪是否在线">
      <template slot-scope="{row}">
        <div v-if="row.gunConnectionState">
          <el-tag :type="row.gunConnectionState.code | gunConnectionStateFilter">
            {{ row.gunConnectionState.message }}
          </el-tag>
        </div>
      </template>
    </af-table-column>
    <af-table-column width="120" label="枪工作状态">
      <template slot-scope="{row}">
        <div v-if="row.state">
          <el-tag :type="row.state.code | stateFilter">
            {{ row.state.message }}
          </el-tag>
        </div>
      </template>
    </af-table-column>
    <af-table-column width="120" label="车连接状态">
      <template slot-scope="{row}">
        <div v-if="row.carConnectionState">
          <el-tag :type="row.carConnectionState.code | carConnectionStateFilter" size="100">
            {{ row.carConnectionState.message }}
          </el-tag>
        </div>
      </template>
    </af-table-column>
    <af-table-column label="操作" width="240px">
      <template slot-scope="scope">
        <el-button size="mini" plain @click="gunDetail(scope.$index, scope.row)">详情</el-button>
        <el-button size="mini" @click="gunEdit(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:gun:saveOrUpdateGunEdit'])">编辑
        </el-button>
<!--        <el-button size="mini" type="danger" @click="gunDelete(scope.$index, scope.row)"
                   v-if=" checkPermission(['bee:res:gun:deleteGun'])">删除
        </el-button>-->
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "list",
    data(){
      return{

      }
    },
    props:{
      gunDataTable:{},
      listLoading:false,
    },
    methods:{
      gunDetail(index,row){
        this.$emit("gunDetail",index,row)
      },
      gunEdit(index,row){
        this.$emit("gunEdit",index,row)
      },
      gunDelete(index,row){
        this.$emit("gunDelete",index,row)
      }
    },
    filters: {
      stateFilter(state) {
        const statusMap = {
          '-1': 'info',  // 离线
          0: 'success',  // 空闲
          1: 'warning',     //启动充电中
          2: 'warning',    //充电进行中
          3: 'primary',   //充电结束
          4: 'danger',   //启动充电失败
          5: 'danger',   //预约充电中
          6: 'info'    //充电终端故障
        }
        return statusMap[state]
      },
      gunConnectionStateFilter(state) {
        if (state == null) {
          state = 1;
        }
        const statusMap = {
          0: 'info',  // 离线
          1: 'success',     //在线
        }
        return statusMap[state]
      },
      carConnectionStateFilter(state) {
        if (state == null) {
          state = 1;
        }
        const statusMap = {
          0: 'info',  // 断开
          1: 'success',     //连接
          2: 'success'     //半连接
        }
        return statusMap[state]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/charginggunManager/list.vue